// extracted by mini-css-extract-plugin
export default {"searchBar":"Search_searchBar__08+Mt","searchBarInput":"Search_searchBarInput__MfE28","icon":"Search_icon__bRMI9"};